import styled, { css } from 'styled-components';
import arrowIcon from 'assets/icons/arrow.png';
import { Icon } from 'AppStyles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.5rem;
  gap: 2.5rem;
  color: #415462;
  max-width: 650px;
  margin: auto;
  @media (max-width: 560px) {
    padding: 2.5rem 1.5rem;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #ffffff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 0.25rem;
`;

export const Title = styled.span`
  font-size: 1.3em;
  font-weight: 700;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 1.5rem;
  gap: 1rem;
  overflow: hidden;
`;

export const List = styled.ul``;

export const Item = styled.li`
  font-size: 1.2em;
  margin-bottom: 0;
`;

export const Total = styled.div`
  background-color: #fbfbfc;
  border-top: 1px solid #edf0f3;
  padding: 2rem 1.5rem;
  font-size: 1.2em;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-left: 0.3rem;
`;

export const Label = styled.label`
  font-weight: 500;
  ${({ $required }) =>
    $required &&
    css`
      &:after {
        content: ' *';
        color: #962222;
      }
    `}
`;

export const Input = styled.input`
  font-size: 1.03em;
  padding: 0.8rem;
  color: #415462;
  &::placeholder {
    opacity: 0.8;
  }
  &:focus {
    outline-color: #00aeef;
  }
`;

export const Error = styled.div`
  color: #d32f2f;
  margin-left: 0.2rem;
  font-size: 0.85em;
  font-weight: 500;
`;

export const LastSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 0.3rem;
`;

export const RememberMe = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.8em;
  margin-bottom: 0.3rem;
`;

export const Checkbox = styled.input.attrs(() => ({
  type: 'checkbox',
  id: 'remember_me',
}))`
  accent-color: #009dd7;
`;

export const NextButton = styled.button`
  display: flex;
  align-items: center;
  color: #ffffff;
  background-color: #00aeef;
  border: unset;
  border-radius: 4px;
  font-size: 1.05em;
  font-weight: 600;
  gap: 0.4rem;
  padding: 0.3rem 0.4rem;
  cursor: pointer;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4);
  }
  &:hover:after {
    width: 120%;
    background-color: rgba(255, 255, 255, 0);
    -webkit-transition: all 0.4s ease-in-out;
    -moz-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }
  &:disabled {
    ${({ $isLoading }) =>
      $isLoading &&
      css`
        padding: 0.4rem 0.5rem;
        gap: 0.7rem;
      `}
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const NextIcon = styled(Icon).attrs(() => ({
  src: arrowIcon,
}))`
  filter: invert(1);
  transform: rotate(180deg);
  width: 22px;
`;

export const CheckoutForm = styled.div.attrs(() => ({
  id: 'checkoutForm',
}))`
  display: ${({ $currentStep }) => ($currentStep === 1 ? 'none' : 'block')};
  .item-selected {
    border: 2px solid #00aeef !important;
  }
  input:checked ~ .checkmark,
  .sfc-cfa-button {
    box-sizing: border-box;
    background-color: #00aeef !important;
    &:hover {
      background-color: #0096cc !important;
      transition: 0.5s;
    }
  }
  input:focus,
  .sfc-focus {
    box-shadow: unset !important;
    border: 1px solid #00aeef !important;
  }
  label {
    color: #4a5568 !important;
  }
`;

export const FormStepsContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const BackIcon = styled(Icon).attrs(() => ({
  src: arrowIcon,
}))`
  position: absolute;
  left: 0;
`;
